import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-contact-and-support-dialog',
  templateUrl: './contact-and-support-dialog.component.html',
  styleUrls: ['./contact-and-support-dialog.component.scss'],
  standalone: false,
})
export class ContactAndSupportDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ContactAndSupportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit(): void {}

  onClickClose(): void {
    this.dialogRef.close();
  }
}
